/*!
 * Copyright (c) 2017-2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var jsonld = require('jsonld');

var forge = require('node-forge');

var LinkedDataSignature2015 = require('./LinkedDataSignature2015');

module.exports = /*#__PURE__*/function (_LinkedDataSignature) {
  _inherits(GraphSignature2012, _LinkedDataSignature);

  function GraphSignature2012() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        privateKeyPem = _ref.privateKeyPem,
        publicKeyPem = _ref.publicKeyPem,
        creator = _ref.creator,
        date = _ref.date,
        domain = _ref.domain,
        nonce = _ref.nonce;

    _classCallCheck(this, GraphSignature2012);

    return _possibleConstructorReturn(this, _getPrototypeOf(GraphSignature2012).call(this, {
      type: 'GraphSignature2012',
      privateKeyPem: privateKeyPem,
      publicKeyPem: publicKeyPem,
      creator: creator,
      date: date,
      domain: domain,
      nonce: nonce
    }));
  }

  _createClass(GraphSignature2012, [{
    key: "canonize",
    value: function () {
      var _canonize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, _ref2) {
        var documentLoader, expansionMap, skipExpansion;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap, skipExpansion = _ref2.skipExpansion;
                return _context.abrupt("return", jsonld.canonize(input, {
                  algorithm: 'URGNA2012',
                  format: 'application/n-quads',
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  skipExpansion: skipExpansion
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function canonize(_x, _x2) {
        return _canonize.apply(this, arguments);
      }

      return canonize;
    }()
    /**
     * @param document {object} to be signed/verified.
     * @param proof {object}
     * @param documentLoader {function}
     * @param expansionMap {function}
     * @param compactProof {boolean}
     *
     * @returns {Promise<{Uint8Array}>}.
     */

  }, {
    key: "createVerifyData",
    value: function () {
      var _createVerifyData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var document, proof, documentLoader, expansionMap, c14n, verifyData, buffer;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                document = _ref3.document, proof = _ref3.proof, documentLoader = _ref3.documentLoader, expansionMap = _ref3.expansionMap;
                _context2.next = 3;
                return this.canonize(document, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 3:
                c14n = _context2.sent;
                verifyData = '';

                if (proof.nonce !== null && proof.nonce !== undefined) {
                  verifyData += proof.nonce;
                }

                verifyData += proof.created;
                verifyData += c14n;

                if (proof.domain !== null && proof.domain !== undefined) {
                  verifyData += '@' + proof.domain;
                }

                buffer = new forge.util.ByteBuffer(verifyData, 'utf8');
                return _context2.abrupt("return", forge.util.binary.raw.decode(buffer.getBytes()));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createVerifyData(_x3) {
        return _createVerifyData.apply(this, arguments);
      }

      return createVerifyData;
    }()
  }]);

  return GraphSignature2012;
}(LinkedDataSignature2015);